import axios from "services/api";;
import { API2_HOST } from 'helpers/urlHelper';
import { BaseTableRS } from 'components/pages/stock-location/models/BaseTable';
import { objectToQueryString } from 'helpers/utils'
import { ApiResponse } from 'helpers/stockLocationHelpers'
axios.defaults.withCredentials = true;

const baseUrl = `${API2_HOST}/user-permissions`;

const search = async (request, userId) => {
    const params = userId ? { ...request, userId } : request;
    const res = await axios({
        method: 'get',
        url: `${baseUrl}?${objectToQueryString(params)}`,
    })
        .catch((error) => {
            console.log('AXIOS ERROR', error)
            return new BaseTableRS([], 0);
        });

    if (res.status !== 200)
        return new BaseTableRS([], 0);

    return new BaseTableRS(res.data?.data?.items, res.data?.data?.total);
}

const getById = async (id) => {
    const result = new ApiResponse();
    const res = await axios({
        method: 'get',
        url: `${baseUrl}/${id}`,
    })
        .catch((error) => {
            console.log('AXIOS ERROR', error)
            return result;
        });

    if (res.status !== 200) {
        return result;
    }
    result.success = res.data.success;
    result.data = res.data?.data
    result.message = res.data?.message;
    return result;
}

const post = async (request) => {
    const result = new ApiResponse();
    if (!request) return result;
    const res = await axios({
        method: 'post',
        url: `${baseUrl}`,
        data: { ...request },
        config: {
            headers: {
                'Accept': 'application/json',
                'Content-type': 'application/json'
            }
        },
    })
        .catch((error) => {
            console.log('ERROR: ', { ...error });
            return result;
        });
    if (res.status !== 200) {
        return result;
    }

    result.success = res.data.success;
    result.data = res.data?.data
    result.message = res.data?.message;
    return result;
}

const patch = async (request, id) => {
    const result = new ApiResponse();
    if (!request || id <= 0) return result;
    const res = await axios({
        method: 'patch',
        url: `${baseUrl}/${id}`,
        data: { ...request },
        config: {
            headers: {
                'Accept': 'application/json',
                'Content-type': 'application/json'
            }
        },
    })
        .catch((error) => {
            console.log('ERROR: ', { ...error });
            return result;
        });

    if (res.status !== 200) {
        return result;
    }
    result.success = res.data.success;
    result.data = res.data?.data
    result.message = res.data?.message;
    return result;
}

export { search, getById, post, patch };

